module.exports = __webpack_public_path__ + "img/vol06_character_thumb07.3d7f02df.png";